//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uploadImg from '@/assets/img/upload_cross.png'
import { isImage } from '@/utils/validator'
import fileIcon from '@/assets/img/file_icon.png'
import { cloneDeep } from '@/utils/lodash'
import { uploadAttachment } from '@/https/prepareEnroll'
import TFixedAttachmentFile from './TFixedAttachmentFile'

export default {
  components: { TFixedAttachmentFile },

  props: {
    options: {
      type: Object,
      default: () => ({}),
    },

    uploadMethod: {
      type: Function,
      default: uploadAttachment,
    },
  },

  data () {
    return {
      uploadImg,
      fileIcon,
    }
  },

  computed: {
    attachmentList () {
      const enrollFixList = cloneDeep(this.options?.bmbMbDetailItem?.bmbFjList || [])

      const attachList = this.options?.fjList || []

      return enrollFixList.map((el, index) => {
        const data = attachList.find((item) => item.fjmc === el.fjmc) || {}

        if (data) {
          return {
            ...el,
            ...data,
            index,
            url: data.fjdz,
          }
        } else {
          return el
        }
      })
    },

    configData () {
      return this.options?.bmbMbDetailItem || {}
    },
  },

  methods: {
    isImage,

    async validate () {
      if (this.attachmentList.every((el) => (el.url?.length && +el.sfbtdm) || !+el.sfbtdm)) {
        return true
      } else {
        return false
      }
    },

    onChange (val) {
      this.attachmentList[val.index] = {
        ...this.attachmentList[val.index],
        ...val,
      }
    },

    handlerUploadSuccess (item, fileList) {
      this.$set(item, 'url', fileList[0].url)
    },

    deleteFile (item) {
      this.$set(item, 'uploadModelList', [])
    },

    async getUploadStatus (status, item) {
      // this.$set(item, 'fineshed', status === 'done')
    },
  },
}
